import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('@/pages/login/AppLogin.vue'),
  },
  {
    path: '/',
    redirect: '/overview',
    name: 'layout',
    component: () => import('@/pages/layout/FrontLayout.vue'),
    children: [
      {
        path: 'overview',
        name: 'overview',
        meta: {
          title: '概览',
        },
        component: () => import('@/pages/overview/OverviewPage.vue'),
      },
      {
        path: 'myInfo',
        name: 'myInfo',
        meta: {
          title: '我的',
        },
        component: () => import('@/pages/my-info/MyInfo.vue'),
      },
      {
        path: 'personRights',
        name: 'personRights',
        meta: {
          title: '权限管理',
        },
        component: () => import('@/pages/person/rights/StaffRights.vue'),
      },
      {
        path: 'staffManage',
        name: 'staffManage',
        meta: {
          title: '员工管理',
        },
        component: () => import('./CommonContainer.vue'),
        children: [
          {
            path: '',
            name: 'staffList',
            meta: {
              title: '员工列表',
              keepAlive: true,
            },
            component: () => import('@/pages/person/staff-manage/StaffManage.vue'),
          },
          {
            path: 'addStaff',
            name: 'addStaff',
            meta: {
              title: '新建员工',
            },
            component: () => import('@/pages/person/staff-manage/AddStaff.vue'),
          },
          {
            path: 'editStaff',
            name: 'editStaff',
            meta: {
              title: '员工详情',
            },
            component: () => import('./CommonContainer.vue'),
            children: [
              {
                path: '',
                name: 'staffDetail',
                meta: {
                  name: 'staffDetail',
                  keepAlive: true,
                },
                component: () => import('@/pages/person/staff-manage/EditStaff.vue'),
              },
              {
                path: 'visitDetail',
                name: 'visitDetail',
                meta: {
                  title: '拜访详情',
                },
                component: () => import('@/pages/person/staff-manage/VisitDetails.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'custom',
        name: 'custom',
        meta: { title: '客户管理' },
        component: () => import('./CommonContainer.vue'),
        children: [
          {
            path: '',
            name: 'customList',
            component: () => import('@/pages/custom-manage/CustomManage.vue'),
          },
          {
            path: 'customDetail',
            name: 'customDetail',
            meta: { title: '客户详情' },
            component: () => import('@/pages/custom-manage/CustomDetail.vue'),
          },
        ],
      },
      {
        path: 'visitorManage',
        name: 'visitorManage',
        meta: {
          title: '外访登记管理',
        },
        component: () => import('./CommonContainer.vue'),
        children: [
          {
            path: '',
            name: 'visitorStatic',
            meta: {
              title: '外访统计',
              keepAlive: true,
            },
            component: () => import('@/pages/visitor/VisitorStatic.vue'),
          },
        ],
      },
      {
        path: 'milestone-checkin',
        name: 'milestoneCheckin',
        meta: {
          title: '里程打卡',
        },
        component: () => import('@/pages/visitor/MilestoneCheckin.vue'),
      },
      {
        path: 'milestone-detail',
        name: 'milestoneDetail',
        meta: {
          title: '里程打卡详情',
        },
        component: () => import('@/pages/visitor/MilestoneCheckinDetail.vue'),
      },
      // {
      //   path: 'visitorManage',
      //   name: 'visitorManage',
      //   meta: {
      //     title: '登记项管理',
      //   },
      //   component: () => import('@/pages/visitor/VisitorManage.vue'),
      // },
      {
        path: 'category',
        name: 'category',
        meta: {
          title: '分销品类管理',
        },
        component: () => import('@/pages/category/CategoryManage.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0, behavior: 'smooth' }
  },
})

export default router
